/**
 *  Prepend theme related scripts
 */

//IE polyfills
require('nodelist-foreach-polyfill');
import smoothscroll from 'smoothscroll-polyfill';
require('./_campaign-page.js');
require('./_faq-handler.js');
require('./_hero-video.js');
require('./_vimeo-oembed.js');
require('./_donation-multiplier.js');
require('./_scrollReveal-animations.js');
require('./_woocart.js');
require('./_copy-link.js');
require('./_navigation.js');
require('./_popup.js');
require('./_ecart-editor.js');
require('./_donation-highlight.js');
require('./_projects_map.js');
import browser from './_whatBrowser';
import gaEventsHandlerApp from './_ga-events-handler.js';
// import { debounce } from "debounce";

var solidaarisuusApp = function () {
    // variables & binds here
    const body = document.body;

    var resize = function () {
        //call all resize related functions here
    }

    var init = function () {
        //Call functions to be used in init

        if (!body.classList.contains('page-template-template-donate')) {
            // handleDesktopNav();
            handleMobileNav();
        }

        let header = document.querySelector('header.header');

        let scrollTop = window.pageYOffset;

        if (header) {
            // Check that we have scrolled far enough
            if (scrollTop > 0.1) {
                header.classList.add('scroll');
            } else {
                header.classList.remove('scroll');
            }
        }

        gaEventsHandlerApp.init();
    }

    var scroll = function () {
        //Add window scroll related functions here
        if (!body.classList.contains('page-template-template-donate')) {
            maybeStickyNavMenu();
        }
    }


    /*FUNCTIONS
    ##########################################################################################**/

    //Toggle mobile navigation menu
    function handleMobileNav() {
        let navToggle = document.querySelector('.nav-toggle');

        if (!navToggle) {
            return; // Exit the function if navToggle doesn't exist
        }

        navToggle.addEventListener('click', function (e) {
            e.preventDefault();
            document.body.classList.toggle('menu-open');
            document.querySelector('html').classList.toggle('nav-open');
        });
    }

    //Handle second lvl stuff & inserting additional html
    function handleDesktopNav() {

        const navsWithChilds = document.querySelectorAll('#desktop-nav .menu-item-has-children');
        const header = document.getElementById('desktop-nav');

        navsWithChilds.forEach(function (elem) {

            // Add mouse event actions
            elem.addEventListener('click', function (e) {
                header.classList.add('white-hover');
            });

            elem.addEventListener('click', function (e) {
                // header.classList.remove('white-hover');
            });

            // Add cta elements. This is really dumb
            let links = elem.querySelectorAll('ul.sub-menu li a');
            let ctaTxt = 'Lue lisää';

            if (location.href.indexOf('/en/') > -1) {
                ctaTxt = 'See how';
            } else {
                ctaTxt = 'Lue lisää';
            }

            // links.forEach( function( el ) {
            //     let cta = document.createElement('span');
            //     cta.classList.add('cta');
            //     cta.classList.add('red');
            //     cta.innerHTML = ctaTxt;
            //     el.appendChild(cta);
            // } );
        });
    }

    //Add sticky classes on scroll
    function maybeStickyNavMenu() {
        let header = document.querySelector('header.header');

        if (!header) {
            return; // Exit the function if header doesn't exist
        }

        let scrollTop = window.pageYOffset;

        //Check that we have scrolled far enough
        if (scrollTop > 0.1) {
            header.classList.add('scroll');
        } else {
            header.classList.remove('scroll');
        }
    }

    function timestamp() {
        var response = document.getElementById("g-recaptcha-response");
        if (response == null || response.value.trim() == "") {
            var elems = JSON.parse(document.getElementsByName("captcha_settings")[0].value);
            elems["ts"] = JSON.stringify(new Date().getTime());
            document.getElementsByName("captcha_settings")[0].value = JSON.stringify(elems);
        }
    }

    if (document.getElementById("g-recaptcha-response")) {
        setInterval(timestamp, 500);
    }

    // If the 'hide cookie is not set we show the message
    if (!readCookie('hide')) {
        jQuery('#notice').show();
    } else {
        jQuery('#notice').hide();
    }

    let closeNoticeButton = document.querySelector('#notice .close-notice');

    // Add the event that closes the popup and sets the cookie that tells us to
    // not show it again until one day has passed.
    if (closeNoticeButton) {
        document.querySelector('#notice .close-notice').addEventListener('click', function() {
            document.querySelector('#notice').style.display = 'none';
            createCookie('hide', true, 1)
            return false;
        });
    }

    // ---
    // And some generic cookie logic
    // ---
    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    return { init: init, resize: resize, scroll: scroll }
}();

// BINDS TO INIT, RESIZE ETC
document.addEventListener("DOMContentLoaded", function () {
    solidaarisuusApp.init();
});

window.addEventListener("resize", function () {
    solidaarisuusApp.resize();
});

window.addEventListener('scroll', function () {
    solidaarisuusApp.scroll();
});

// window.addEventListener('beforeunload', function() {
//     document.querySelector('section.page-hero').classList.add('fade-out');
// });